import {
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
} from "@mui/material";
import React, { ChangeEvent, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { axiosGet } from "../../util/axios";
import {
    initContainerListThunk,
    initReyclableListThunk,
} from "../../redux/staticInfo/thunk";
import { OpenSnackBarWithResultFail } from "../../redux/common/snackBar/thunk";
import { ChangeCollectionWeightThunk, ChangeContainerThunk, ChangeRecyclabeThunk } from "../../redux/collection/thunk";

function EditCollectionData() {
    const dispatch = useDispatch<IRootThunkDispatch>();
    const { selectedEditCollectionDetail } = useSelector(
        (state: IRootState) => state.collectionState
    );

    const { recylcableList, containerList } = useSelector(
        (state: IRootState) => state.staticInfoState
    );

    useEffect(() => {
        getFormData();
    }, []);

    async function getFormData() {
        const containerResult = await axiosGet("/api/collection/containerList");
        if (containerResult.data.success) {
            dispatch(
                initContainerListThunk(containerResult.data.containerList)
            );
        } else {
            dispatch(OpenSnackBarWithResultFail("未能下載收集容器"));
        }

        const recyclableResult = await axiosGet(
            "/api/collection/recyclableList"
        );
        if (recyclableResult.data.success) {
            dispatch(
                initReyclableListThunk(recyclableResult.data.recylcableList)
            );
        } else {
            dispatch(OpenSnackBarWithResultFail("未能下載收集類型"));
        }
    }

    function handleChangeRecycle(event: SelectChangeEvent<string>){
        dispatch(ChangeRecyclabeThunk(recylcableList,event.target.value))
    }


    function handleChangeContainer(event: SelectChangeEvent<string>){
        dispatch(ChangeContainerThunk(containerList,event.target.value,selectedEditCollectionDetail?.collection_weight.toString()!))
    }

    function handleCollectionWeightChange(event:ChangeEvent<HTMLInputElement>){
        dispatch(ChangeCollectionWeightThunk(containerList,selectedEditCollectionDetail?.container_id!,event.target.value))
    }

    return (
        <Grid>
            <Grid style={{display:'flex',padding:'20px'}}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                        回收類型
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedEditCollectionDetail?.recyclable_id}
                        label="回收類型"
                        onChange={handleChangeRecycle}
                    >
                        {recylcableList.map((recylcable, index) => (
                            <MenuItem
                                value={recylcable.recyclable_id}
                                key={`recylcable-${index}`}
                            >
                                {recylcable.recyclable}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                        回收容器
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedEditCollectionDetail?.container_id}
                        label="回收類型"
                        onChange={handleChangeContainer}
                    >
                        {containerList.map((container, index) => (
                            <MenuItem
                                value={container.container_id}
                                key={`container-${index}`}
                            >
                                {container.container}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth>
                    <TextField
                        id="outlined-basic"
                        label="總重量"
                        variant="outlined"
                        type="number"
                        onChange={handleCollectionWeightChange}
                        value={selectedEditCollectionDetail?.collection_weight}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <TextField
                        id="outlined-basic"
                        label="淨重量"
                        variant="outlined"
                        type="number"
                        value={selectedEditCollectionDetail?.net_weight}
                        disabled
                    />
                </FormControl>
            </Grid>
        </Grid>
    );
}

export default EditCollectionData;
